import React from 'react';
import Navbar from '@/components/layout/Navbar';
import HeroSection from '@/components/sections/HeroSection';
import ValueProposition from '@/components/sections/ValueProposition';
import FeaturesSection from '@/components/sections/FeaturesSection';
import DashboardShowcase from '@/components/sections/DashboardShowcase';
import MetricsSection from '@/components/sections/MetricsSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import CtaSection from '@/components/sections/CtaSection';
import Footer from '@/components/layout/Footer';
import HowItWorksSection from '@/components/sections/HowItWorksSection';
import PricingSection from '@/components/sections/PricingSection';
import FAQ from '@/components/sections/FaqSection';

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ValueProposition />
        <FeaturesSection />
        <HowItWorksSection />
        <DashboardShowcase />
        <MetricsSection />
        <PricingSection />
        {/* <TestimonialsSection /> */}
        <CtaSection />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
